import React, { useMemo } from 'react';
import { PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, RadarChart, ResponsiveContainer } from 'recharts';

interface WindRoseChartProps {
  loading?: boolean;
}

const WindRoseChart: React.FC<WindRoseChartProps> = ({ loading }) => {
  if (loading) {
    return (
      <div className="h-48 flex items-center justify-center">
        <div className="animate-pulse bg-gradient-to-r from-slate-200 via-slate-300 to-slate-200 w-full h-full rounded-xl"></div>
      </div>
    );
  }

  const windData = useMemo(() => [
    { direction: 'N', speed: 8 },
    { direction: 'NE', speed: 6 },
    { direction: 'E', speed: 4 },
    { direction: 'SE', speed: 7 },
    { direction: 'S', speed: 9 },
    { direction: 'SW', speed: 12 },
    { direction: 'W', speed: 10 },
    { direction: 'NW', speed: 5 }
  ], []);

  return (
    <div className="w-full h-48 bg-gradient-to-br from-slate-50 to-white rounded-xl border border-slate-200 p-4">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={windData}>
          <PolarGrid stroke="#e2e8f0" />
          <PolarAngleAxis dataKey="direction" tick={{ fontSize: 12, fill: '#64748b' }} />
          <PolarRadiusAxis 
            angle={90} 
            domain={[0, 15]} 
            tick={{ fontSize: 10, fill: '#64748b' }}
          />
          <Radar
            name="Wind Speed"
            dataKey="speed"
            stroke="#06b6d4"
            fill="#06b6d4"
            fillOpacity={0.3}
            strokeWidth={2}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WindRoseChart;